const findImage = (allFile, filename) => {
  if(filename.match(/\.\w+\b/g)){
    throw new Error(`Have you accidentally included the file extension? - ${filename}`)
    // Check that the filename does not include an extension and if it does throw an error
  }
  const edge = allFile.edges.find(edge => {
    // Initially we were checking the file name was included but this provided erroneous images,
    // now we're checking for an exact match with the filename found and the one provided
    const match = /\/([^/]+)\.\w+$/.exec(edge.node.childImageSharp?.gatsbyImageData?.images.fallback.src)
    return match?.[1] === filename;
    })

  if (!edge) {
    throw new Error(`Cannot find an image matching ${filename}`)
  }

  return edge.node
}

export default findImage
